(function () {
  'use strict';

  var SECTION_CLASS = 'shopify-section--hotspot';

  var IS_EDITOR = !!(window.Shopify && Shopify.designMode);

  function initHotspot(section, forceRebuild) {
    var layout = section.querySelector('[data-hotspot-layout]');
    if (!layout) return;

    var panel = section.querySelector('[data-hotspot-panel]');
    var dotsArea = section.querySelector('[data-hotspot-dots]');
    if (!panel || !dotsArea) return;

    if (panel.dataset.hotspotInit) {
      if (!forceRebuild) return;
      destroyHotspot(section);
    }

    var wrapper = panel.querySelector('[data-hotspot-wrapper]');
    if (!wrapper) return;

    var items = Array.from(dotsArea.querySelectorAll('[data-hotspot-item]'));
    if (!items.length) return;

    panel.dataset.hotspotInit = '1';

    var perView = parseInt(panel.dataset.slidesDesktop, 10) || 3;

    var desktopMQ = window.matchMedia('(min-width: 768px)');
 
    //  MOBILE BOTTOM SHEET  (Bootstrap responsive offcanvas) 
    var sheet = section.querySelector('[data-hotspot-sheet]');
    var lastOpener = null;

    function getOffcanvas() {
      if (!sheet || !window.bootstrap || !bootstrap.Offcanvas) return null;
      if (desktopMQ.matches) return null; // never instantiate on desktop
      return bootstrap.Offcanvas.getOrCreateInstance(sheet);
    }

    function openSheet(index, opener) {
      var oc = getOffcanvas();
      if (!oc) return;
      lastOpener = opener || null;
      sheet.__pendingIndex = index;
      oc.show();
    }

    function disposeSheet() {
      if (!sheet || !window.bootstrap || !bootstrap.Offcanvas) return;
      var inst = bootstrap.Offcanvas.getInstance(sheet); 
      if (inst) { inst.hide(); inst.dispose(); }
      sheet.classList.remove('show', 'showing', 'hiding');
    }

    wrapper.textContent = '';
    items.forEach(function (item, idx) {
      var card = item.querySelector('[data-hotspot-card]');
      if (!card) return;
      var slide = document.createElement('div');
      slide.className = 'swiper-slide m-0 hotspot-slide';
      slide.dataset.hotspotIndex = idx;
      slide.dataset.realIndex = idx;
      slide.appendChild(card.cloneNode(true));
      wrapper.appendChild(slide);
    });

    var slides = Array.from(wrapper.querySelectorAll('.hotspot-slide'));
    if (!slides.length) return;

    var activeIndex = -1;

     
    function setActiveClasses(index) {
      if (activeIndex >= 0 && items[activeIndex]) {
        items[activeIndex].classList.remove('hotspot-item--active');
      }
      activeIndex = index;
      if (items[activeIndex]) items[activeIndex].classList.add('hotspot-item--active');

      wrapper.querySelectorAll('.hotspot-slide').forEach(function (slide) {
        var real = parseInt(slide.dataset.realIndex, 10);
        slide.classList.toggle('hotspot-slide--active', real === activeIndex);
      });

      if (desktopMQ.matches) setNeighborClasses();
    }
 
    //  NEIGHBOUR CLASSES  (--prev / --next, by visual position) 
    function slidesByDistanceFromCenter() {
      var horizontal = !desktopMQ.matches;
      var panelRect = panel.getBoundingClientRect();
      var mid = horizontal
        ? panelRect.left + panelRect.width / 2
        : panelRect.top + panelRect.height / 2;

      var out = [];
      wrapper.querySelectorAll('.hotspot-slide').forEach(function (slide) {
        var r = slide.getBoundingClientRect(); 
        if (!r.width || !r.height) return;
        var delta = horizontal
          ? (r.left + r.width / 2) - mid
          : (r.top + r.height / 2) - mid;
        out.push({ el: slide, realIndex: parseInt(slide.dataset.realIndex, 10), delta: delta });
      });

      out.sort(function (a, b) { return Math.abs(a.delta) - Math.abs(b.delta); });
      return out;
    } 
    function syncSlideReachability() {
      wrapper.querySelectorAll('.hotspot-slide').forEach(function (s) {
        var reachable =
          s.classList.contains('hotspot-slide--active') &&
          !s.classList.contains('hotspot-slide--clone');
        if (reachable) {
          s.removeAttribute('inert');
          s.removeAttribute('aria-hidden');
        } else {
          s.setAttribute('inert', '');
          s.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function clearNeighborClasses() {
      wrapper.querySelectorAll('.hotspot-slide').forEach(function (s) {
        s.classList.remove('hotspot-slide--prev', 'hotspot-slide--next');
        s.removeAttribute('inert');
        s.removeAttribute('aria-hidden');
      });
    }

    function setNeighborClasses() {
      var ranked = slidesByDistanceFromCenter();
      if (!ranked.length) { clearNeighborClasses(); return; } 
      var center = ranked[0];
      var prev = null;
      var next = null;
      for (var i = 1; i < ranked.length; i++) {
        if (ranked[i].realIndex === center.realIndex) continue;
        var d = ranked[i].delta - center.delta;
        if (d < 0 && !prev) prev = ranked[i].el;
        else if (d > 0 && !next) next = ranked[i].el;
        if (prev && next) break;
      }

      wrapper.querySelectorAll('.hotspot-slide').forEach(function (s) {
        s.classList.toggle('hotspot-slide--prev', s === prev);
        s.classList.toggle('hotspot-slide--next', s === next);
      });
      syncSlideReachability();
    }
 
    var neighborRAF = 0;
    function scheduleNeighborClasses() {
      if (neighborRAF) return;
      neighborRAF = requestAnimationFrame(function () {
        neighborRAF = 0;
        setNeighborClasses();
      });
    }
 
    //  DESKTOP MARQUEE  (no Swiper) 
    var marquee = null;

    function buildMarquee() {
      var contentH = 0; 
      var offset = 0;  
      var cloneCount = 0;

      panel.classList.add('hotspot-panel--marquee');

      function measure() { 
        var gap = parseFloat(getComputedStyle(wrapper).rowGap) || 0;
        var total = 0;
        for (var i = 0; i < slides.length; i++) {
          total += slides[i].getBoundingClientRect().height;
        }
        total += gap * slides.length;  
        contentH = total;
      }

      function ensureClones() { 
        removeClones();
        var viewportH = panel.getBoundingClientRect().height || 0; 
        var setsNeeded = contentH > 0 ? Math.max(1, Math.ceil(viewportH / contentH) + 1) : 1;
        for (var s = 0; s < setsNeeded; s++) {
          slides.forEach(function (slide) {
            var clone = slide.cloneNode(true);
            clone.classList.add('hotspot-slide--clone');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            wrapper.appendChild(clone);
            cloneCount++;
          });
        }
      }

      function removeClones() {
        wrapper.querySelectorAll('.hotspot-slide--clone').forEach(function (c) {
          c.parentNode.removeChild(c);
        });
        cloneCount = 0;
      }

      function apply() {
        wrapper.style.transform = 'translate3d(0,' + offset + 'px,0)';
        scheduleNeighborClasses();
      }

      function normalize() {
        if (contentH <= 0) return; 
        while (offset <= -contentH) offset += contentH;
        while (offset > 0) offset -= contentH;
      }

      function syncPanelHeight() { 
        var img = layout.querySelector('.hotspot-image');
        if (!img) return;
        var h = img.getBoundingClientRect().height;
        if (h > 0) panel.style.setProperty('--hotspot-panel-h', Math.round(h) + 'px');
      }

      function recalc() {
        syncPanelHeight();
        measure();
        ensureClones();
        normalize();
        apply(); 
        if (activeIndex >= 0 && !dragging) scrollToIndex(activeIndex, true);
      }

      // ── Drag to scroll up / down ───────────────────────────────
      var dragging = false;
      var dragStartY = 0;
      var dragStartOffset = 0;
      var dragMoved = false;

      function onPointerDown(e) {
        if (e.button != null && e.button !== 0) return;

        var interactive = e.target.closest(
          'a, button, input, select, textarea, [role="button"]'
        );

        if (interactive) return;

        dragging = true;
        dragMoved = false;
        dragStartY = e.clientY;
        dragStartOffset = offset;

        wrapper.style.transition = '';
        panel.classList.add('hotspot-panel--dragging');

        if (panel.setPointerCapture && e.pointerId != null) {
          try {
            panel.setPointerCapture(e.pointerId);
          } catch (err) { }
        }
      }

      function onPointerMove(e) {
        if (!dragging) return;
        var dy = e.clientY - dragStartY;
        if (Math.abs(dy) > 3) dragMoved = true;
        offset = dragStartOffset + dy;
        normalize();
        apply();
        if (dragMoved && e.cancelable) e.preventDefault();
      }

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        panel.classList.remove('hotspot-panel--dragging');
        if (panel.releasePointerCapture && e && e.pointerId != null) {
          try { panel.releasePointerCapture(e.pointerId); } catch (err) {}
        } 
        if (dragMoved) {
          var block = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
          panel.addEventListener('click', block, { capture: true, once: true });
          window.setTimeout(function () {
            panel.removeEventListener('click', block, { capture: true });
          }, 0);
          // Snap the card nearest the panel centre to exact centre and select it.
          settleToCenter();
        }
      }

      panel.addEventListener('pointerdown', onPointerDown);
      panel.addEventListener('pointermove', onPointerMove);
      panel.addEventListener('pointerup', endDrag);
      panel.addEventListener('pointercancel', endDrag);
      panel.addEventListener('pointerleave', endDrag); 
      function onFocusIn() {
        panel.scrollTop = 0;
        wrapper.scrollTop = 0;
      }
      panel.addEventListener('focusin', onFocusIn);

      function scrollToIndex(index, instant) {
        if (contentH <= 0) return;
        var slide = slides[index];
        if (!slide) return;
        var viewportH = panel.getBoundingClientRect().height || 0; 
        var target = -(slide.offsetTop - (viewportH - slide.getBoundingClientRect().height) / 2);
        offset = target;
        normalize();
        wrapper.style.transition = instant ? '' : 'transform 0.4s ease';
        apply(); 
        if (instant) scheduleNeighborClasses();
        window.clearTimeout(scrollToIndex._t);
        scrollToIndex._t = window.setTimeout(function () {
          wrapper.style.transition = '';
          scheduleNeighborClasses();
        }, 450);
      } 
      function centeredRealIndex() {
        var ranked = slidesByDistanceFromCenter();
        return ranked.length ? ranked[0].realIndex : -1;
      }
 
      function settleToCenter() {
        var i = centeredRealIndex();
        if (i >= 0) {
          setActiveClasses(i);
          scrollToIndex(i);
        }
      }

      recalc();
 
      var ro = null;
      if (window.ResizeObserver) {
        ro = new ResizeObserver(function () { recalc(); });
        ro.observe(wrapper);
      }
 
      var hero = layout.querySelector('.hotspot-image__img');
      if (hero && !hero.complete) {
        hero.addEventListener('load', recalc, { once: true });
      }

      marquee = {
        scrollToIndex: scrollToIndex,
        recalc: recalc,
        destroy: function () {
          if (ro) ro.disconnect(); 
          window.clearTimeout(scrollToIndex._t);
          if (neighborRAF) { cancelAnimationFrame(neighborRAF); neighborRAF = 0; }
          clearNeighborClasses();
          panel.removeEventListener('pointerdown', onPointerDown);
          panel.removeEventListener('pointermove', onPointerMove);
          panel.removeEventListener('pointerup', endDrag);
          panel.removeEventListener('pointercancel', endDrag);
          panel.removeEventListener('pointerleave', endDrag);
          panel.removeEventListener('focusin', onFocusIn);
          removeClones();
          wrapper.style.transform = '';
          wrapper.style.transition = '';
          panel.style.removeProperty('--hotspot-panel-h');
          panel.classList.remove('hotspot-panel--marquee');
          panel.classList.remove('hotspot-panel--dragging');
        }
      };
      panel.__marquee = marquee;
    }
 
    //  MOBILE  — no slider: the bottom sheet shows only the active card (CSS-driven)
    function startEngine() {
      if (desktopMQ.matches) buildMarquee();
    }

    function stopEngine() {
      disposeSheet();
      if (marquee) { marquee.destroy(); marquee = null; panel.__marquee = null; }
    }

    function onMQChange() {
      var keep = activeIndex >= 0 ? activeIndex : Math.floor(items.length / 2);
      stopEngine();
      startEngine();
      activate(keep, true);
    }
    if (desktopMQ.addEventListener) {
      desktopMQ.addEventListener('change', onMQChange);
      panel.__hotspotMQHandler = onMQChange;
    }

    if (sheet && !sheet.__hotspotSheetBound) {
      sheet.__hotspotSheetBound = true;

      sheet.addEventListener('shown.bs.offcanvas', function () {
        sheet.__pendingIndex = null;
      });

      sheet.addEventListener('hidden.bs.offcanvas', function () {
        if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
        lastOpener = null;
      });
    }

    function activate(index, instant, shouldOpenSheet, opener) {
      if (index < 0 || index >= items.length) return;
      setActiveClasses(index);

      if (marquee) marquee.scrollToIndex(index, instant);

      if (shouldOpenSheet && !desktopMQ.matches) openSheet(index, opener);
    }

    items.forEach(function (item, idx) {
      var dot = item.querySelector('[data-hotspot-dot]');
      if (!dot) return;
      dot.addEventListener('click', function () {
        // The only path that opens the mobile sheet.
        activate(idx, false, true, dot);
      });
    });

    startEngine(); 
    var initialIndex = Math.floor(items.length / 2);
    activate(initialIndex, true);
 
    section.__hotspotActivate = function (item) {
      var idx = items.indexOf(item);
      if (idx < 0) return;
      activate(idx, false, true, item.querySelector('[data-hotspot-dot]'));
    };
    if (!section.__hotspotSelectBound) {
      section.__hotspotSelectBound = true;
      section.addEventListener('shopify:block:select', function (e) {
        var item = e.target.closest('[data-hotspot-item]');
        if (!item) return; 
        window.setTimeout(function () {
          if (!section.__hotspotActivate) return;
          var live = section.querySelector('[data-hotspot-item="' + item.dataset.hotspotItem + '"]');
          section.__hotspotActivate(live || item);
        }, 0);
      });
    }
  }

  function destroyHotspot(section) {
    var panel = section.querySelector('[data-hotspot-panel]');
    if (!panel) return;

    if (panel.__hotspotMQHandler) {
      var mq = window.matchMedia('(min-width: 768px)');
      if (mq.removeEventListener) mq.removeEventListener('change', panel.__hotspotMQHandler);
      panel.__hotspotMQHandler = null;
    }

    var sheet = section.querySelector('[data-hotspot-sheet]');
    if (sheet && window.bootstrap && bootstrap.Offcanvas) {
      var sheetInst = bootstrap.Offcanvas.getInstance(sheet);
      if (sheetInst) { sheetInst.hide(); sheetInst.dispose(); }
      sheet.__hotspotSheetBound = false;
      sheet.__pendingIndex = null;
    }

    if (panel.__marquee) { panel.__marquee.destroy(); panel.__marquee = null; }

    var wrapper = panel.querySelector('[data-hotspot-wrapper]');
    if (wrapper) {
      wrapper.textContent = '';
      wrapper.style.transform = '';
      wrapper.style.transition = '';
    }

    panel.classList.remove('hotspot-panel--marquee');
    delete panel.dataset.hotspotInit;
  }

  function isSection(node) {
    return node && node.classList && node.classList.contains(SECTION_CLASS);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.shopify-section--hotspot').forEach(function (s) { initHotspot(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  window.addEventListener('load', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { if (isSection(e.target)) { destroyHotspot(e.target); initHotspot(e.target); } });
  document.addEventListener('shopify:section:unload', function (e) { if (isSection(e.target)) destroyHotspot(e.target); });

  if (IS_EDITOR) {
    var reinitFromBlock = function (e) {
      var section = e.target.closest && e.target.closest('.' + SECTION_CLASS);
      if (section) initHotspot(section, true);
    };
    document.addEventListener('shopify:block:select', reinitFromBlock);
    document.addEventListener('shopify:block:deselect', reinitFromBlock);
  }
})();
